import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ClientConfiguration } from '../client-config.service';
import { UserAccountService } from '../user-account.service';
import { Constants } from '../util/constants';
import { environment } from 'src/environments/environment';
import { SearchService } from '../search.service';
import { DeviceDetailsService } from '../device-details.service';
import { Role } from '../entity/employee-info';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

declare var removeNavigationComponentPadding: any;
declare var openZSIQChatWidow: any;
declare var getZohoSIQChatOfflineStatus: any;
declare var setZSIQNameAndMail_CBK: any;
declare var getApiBaseUrl: any;

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
    standalone: false
})
export class SupportComponent implements OnInit {
  njoySpecificBuild: boolean;
  contactNumber= Constants.GALLOP_HELP_CONTACT_NO;
  @Input() searchPopClicked = false;
  @Output() closeHelpComponent = new EventEmitter();
  isMobile = false;
  
  constructor(public userAccountInfoService: UserAccountService,
    private clientConfig: ClientConfiguration,
    private deviceDetailsService: DeviceDetailsService,
    private searchService: SearchService,
    private http: HttpClient
  ) {
    this.njoySpecificBuild = this.userAccountInfoService.isItNjoyBuild();
  }

  changeStyle() {
    if (this.searchPopClicked) {
      if(window.screen.width < 600){
        if(this.isDashboardPage()){
        return { 'border': 'none', 'height': 'max-content', 'box-shadow': 'none','background':'#F5F5FA' };
        }else{
          return { 'border': 'none', 'height': 'max-content', 'box-shadow': 'none','background':'#FFF' };
        }
      } else {
        if(this.isDashboardPage()){
        return { 'border': 'none', 'height': '70vh;', 'box-shadow': 'none','background':'#F5F5FA' };
        }else{
          return { 'border': 'none', 'height': '70vh;', 'box-shadow': 'none','background':'#FFF' };
        }
      }
    } else {
      if(this.isDashboardPage()){
      return { 'border': '1px solid #E1E1E1', 'height': 'calc(100vh - 75px)', 'box-shadow': '0 0 20px 0 var(--light-bg-color)','background':'#F5F5FA' }
      }
      else{
        return { 'border': '1px solid #E1E1E1', 'height': 'calc(100vh - 75px)', 'box-shadow': '0 0 20px 0 var(--light-bg-color)','background':'#FFF' }
      }
    }
  }
  ngOnInit() {
    this.deviceDetailsService.isMobile().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
    setTimeout(() => {
      removeNavigationComponentPadding();
    }, 500);

  }
  getPhoneNo(): any {
    return Constants.GALLOP_HELP_CONTACT_NO;
  }
  getNetherlandPhone(): any{
    return Constants.GALLOP_HELP_CONTACT_NO_NETHERLANDS;
  }
  getEmailId(): any {
    if (this.clientConfig.agentEmailId && this.clientConfig.agentEmailId.trim().length > 0) {
      return this.clientConfig.agentEmailId;
    }
    return 'trip@routespring.com';
  }
  openZSIQChatWidowClick() {
    if (this.userAccountInfoService.getAccountInfo() != null) {
      const userInfo = this.userAccountInfoService.getAccountInfo().userInfo;
      if (userInfo != null) {
        this.closeHelpComponent.emit(true);
        setZSIQNameAndMail_CBK(userInfo.fullName, userInfo.email);
      }
    }
    openZSIQChatWidow();
  }
  isDashboardPage() {
    if(this.userAccountInfoService.getCurrentRouterPath()){
    return this.userAccountInfoService.getCurrentRouterPath().indexOf('admin') === 1;
  }
  }
  isZohoSIQChatOffline() {
    if (!this.searchService.chatEnabled || getZohoSIQChatOfflineStatus()) {
      return true;
    }
    return false;
  }
   isuserHascard(): boolean {
    return this.userAccountInfoService.userhascard;
  }

  canAccessHelpCenter(): boolean {
    // Check if user has TRAVEL_MANAGER or ADMIN role
    const hasRequiredRole = this.userAccountInfoService.getAccountInfo()
        && this.userAccountInfoService.getAccountInfo().userInfo
        && this.userAccountInfoService.getAccountInfo().userInfo.employeeInfo
        && (this.userAccountInfoService.getAccountInfo().userInfo.employeeInfo.role === Role.TRAVEL_MANAGER
            || this.userAccountInfoService.getAccountInfo().userInfo.employeeInfo.role === Role.ADMIN);

    // Check if zohoSSOSupported feature is enabled from initClient response
    const initResponse = this.userAccountInfoService.userAccountInitObjObserver$.value;
    const hasZohoSSOFeature = initResponse
        && initResponse.zohoSSOSupported === true;

    return hasRequiredRole && hasZohoSSOFeature;
  }

  openHelpCenter() {
    if (!this.canAccessHelpCenter()) {
      console.log('Access denied: Help Center is only available to Travel Managers and Admins');
      return;
    }

    // Call API endpoint to get SSO URL for Zoho Help Center
    const apiUrl = `${getApiBaseUrl('default')}/api/helpCenter/sso`;

    // Add common app parameters (consistent with other API calls)
    const params = new HttpParams()
      .set(Constants.PARAM_APP_VERSION, environment.appVersion)
      .set(Constants.PARAM_APPSTORE_VERSION, environment.appStoreVersionName)
      .set(Constants.PARAM_APP_BUILD_NUMBER, environment.appStoreBuildNumber)
      .set(Constants.PARAM_APP_PLATFORM, environment.platform)
      .set('selectedLanguage', localStorage.getItem('selectedLanguage') || 'en')
      .set(Constants.PARAM_OTA_BUILD_NUMBER, environment.otaBuildNumber)
      .set('companyId', this.userAccountInfoService.getUserCompanyId().toString());

    // Add authentication headers (same pattern as other authenticated calls)
    const headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + this.userAccountInfoService.getUserEmail() + ':' + this.userAccountInfoService.getSToken());

    this.http.get<any>(apiUrl, { params, headers }).subscribe(
      (response) => {
        if (response && response.status === "success" && response.data && response.data.redirectUrl) {
          // Open Zoho Help Center with SSO
          if (this.njoySpecificBuild) {
            window.location.href = response.data.redirectUrl + '&dummy=/TripItAPI/';
          }else{
          window.open(response.data.redirectUrl, '_blank');
          }
        } else {
          console.error('Failed to get Help Center SSO URL:', response.message || 'Unknown error');
          // Fallback to direct Zoho link without SSO
          this.openFallbackHelpCenter();
        }
      },
      (error) => {
        console.error('Error calling Help Center SSO API:', error);
        // Fallback to direct Zoho link without SSO
        this.openFallbackHelpCenter();
      }
    );
  }

  private openFallbackHelpCenter() {
    // Fallback URL - could be your Zoho Help Center direct link
    const fallbackUrl = 'https://help.routespring.com/portal/en/kb';
    if (this.njoySpecificBuild) {
      window.location.href = fallbackUrl + '&dummy=/TripItAPI/';
    }else{
    window.open(fallbackUrl, '_blank');
    }
  }
}
